import * as styled from '../../../util/styled'
import { Logo } from '../../../logo/Logo'
import { LoggedInUserMenu } from './LoggedInUserMenu/LoggedInUserMenu'

const TailwindScoped = styled.div('tailwind-scope')
const HeaderBar = styled.div('tailwind-scope flex flex-row items-center justify-between w-full h-full')
const LeftContent = styled.div('py-4 flex flex-row items-center gap-2 pl-4')
const RightContent = styled.div('py-4 flex flex-row items-center gap-2 pr-4')
const Gap = styled.div('flex-grow')
const JROLogo = styled.component(Logo)('h-4 w-4')
const JROLogoText = styled.div('text-brand text-md font-semibold')
const JROLogoSubtext = styled.div('text-text-tertiary text-sm font-normal')

export const HeaderView = () => {
  return (
    <TailwindScoped>
      <HeaderBar>
        <LeftContent>
          <JROLogoText>JustReachOut</JROLogoText>
          <JROLogo />
          <JROLogoSubtext>&ensp;|&ensp;Outreach and Press Campaigns</JROLogoSubtext>
        </LeftContent>
        <Gap />
        <RightContent>
          <LoggedInUserMenu />
        </RightContent>
      </HeaderBar>
    </TailwindScoped>
  )
}